import React from 'react';

export const LocalIntelligenceContainer = React.lazy(() => import('./LocalIntelligenceContainer'));
